export default __webpack_public_path__ + "static/media/doodle_juice_cut.9c129cf1.png";